import React from "react";
import { Steps, Step } from "react-step-builder";
import CovidPage from './covid/covid-page';

function Home() {
    return (
        <div>
            <Steps>
                <Step component={CovidPage} />
                <Step component={CovidPage} />
                <Step component={CovidPage} />
                <Step component={CovidPage} />
            </Steps>
        </div>
    );
}

export default Home;